import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from '@/components/ui/Logo';
import { Github, Mail, ExternalLink } from 'lucide-react';

export const AdminFooter: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-border bg-card mt-auto">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-6">
          <div className="col-span-1 md:col-span-2">
            <Logo variant="full" className="h-8 mb-4" />
            <p className="text-sm text-muted-foreground max-w-md">
              Five AI Content Management Service Admin Panel. Manage your content and surveys with ease.
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-sm">Quick Links</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <Link to="/admin/dashboard" className="hover:text-foreground transition-colors">
                  Dashboard
                </Link>
              </li>
              <li>
                <Link to="/admin/contents" className="hover:text-foreground transition-colors">
                  Content Management
                </Link>
              </li>
              <li>
                <Link to="/admin/surveys" className="hover:text-foreground transition-colors">
                  Survey Management
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-sm">Resources</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <a
                  href="/api/content-management/api-docs"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-foreground transition-colors flex items-center gap-1"
                >
                  API Documentation
                  <ExternalLink className="h-3 w-3" />
                </a>
              </li>
              <li>
                <a
                  href="/api/content-management/swagger-ui/index.html"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-foreground transition-colors flex items-center gap-1"
                >
                  Swagger UI
                  <ExternalLink className="h-3 w-3" />
                </a>
              </li>
              <li>
                <a
                  href="https://github.com/thefiveai"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-foreground transition-colors flex items-center gap-1"
                >
                  GitHub
                  <Github className="h-3 w-3" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border pt-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Logo variant="icon" className="h-5 w-5" />
              <p>© {currentYear} Five AI. All rights reserved.</p>
            </div>
            <div className="flex items-center gap-4 text-sm text-muted-foreground">
              <a
                href="mailto:support@fiveai.co"
                className="hover:text-foreground transition-colors flex items-center gap-1"
              >
                <Mail className="h-4 w-4" />
                Support
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};


